// /*
//  * Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
//  * #  This file forms part of the Trade-DSM application frontend.
//  * #  https://github.com/Tooblippe/trade-dsm-frontend
//  */
//
// export default {
//   computed: {},
//   methods: {
//     save_query_selection(list_type, selection_count, selection_list) {
//       if (this.hs6Selected > 0) {
//         console.log(selection_count);
//         console.log(selection_list);
//         this.list_selection_to_save = [];
//         if (list_type === 'country') {
//           for (let i = 0; i < selection_list.length; i++) {
//             if (selection_list[i].selected) {
//               this.list_selection_to_save.push({
//                 name: selection_list[i].C_Name,
//                 code: selection_list[i].C_Code,
//                 included_in_search: true,
//                 included: selection_list[i].included,
//               });
//             }
//           }
//         }
//
//         if (list_type === 'product') {
//           for (let i = 0; i < selection_list.length; i++) {
//             if (selection_list[i].selected) {
//               this.list_selection_to_save.push({
//                 name: selection_list[i].HS6_Description,
//                 code: selection_list[i].HS6_Code,
//                 included_in_search: true,
//                 included: selection_list[i].included,
//               });
//             }
//           }
//         }
//
//         this.list_operation = 'save';
//         this.dialog = true;
//       }
//     },
//     load_query_selection() {
//       this.list_operation = 'load';
//       this.dialog = true;
//     },
//   },
// };
